import { Block, FormCheckbox, WasteIcon } from '@hvcgroep/design-system';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import * as React from 'react';
import { Container } from '../../types';
import { getContainersByContainerType } from '../../helpers/extractFromContainers';

import './style.scss';
import Button from '../../../../shared/components/Button';
import addressMapsLink from '../../helpers/addressMapsLink';

type Props = {
  name: Container['type'];
  containers: Container[];
  enabled: boolean;
  onChange: (checked: boolean) => void;
};

const ContainerListItem = (props: Props) => {
  const { t } = useTranslation();
  const [visibleContainerCount, setVisibleContainerCount] = React.useState(1);
  const {
    name,
    containers,
    enabled,
    onChange,
  } = props;
  const filteredContainers = getContainersByContainerType(containers, name);
  const classes = c('ContainerList__item', `ContainerList__item--${name.toLocaleLowerCase()}`);

  const handleMoreLocationsClick = () => {
    setVisibleContainerCount((prevCount) => prevCount + 3);
  };

  return (
    <div className={classes}>
      <FormCheckbox
        name={name}
        label={(
          <>
            <WasteIcon streamUid={name} />
            {t(`container_locations.container_list.items.${name}.label`)}
          </>
        )}
        onChange={(e) => {
          if (!e.target.checked) {
            setVisibleContainerCount(0);
          }

          if (e.target.checked) {
            setVisibleContainerCount(1);
          }

          onChange(e.target.checked);
        }}
        isToggle
        checked={enabled}
        verticalSpacing={false}
        tooltip={t(`container_locations.container_list.items.${name}.tooltip`)}
        isLiveValidationDisabled
        className="mb-3"
      />
      {filteredContainers.slice(0, visibleContainerCount).map((container) => {
        let mapsLink;
        let address;

        if ('container_id' in container) {
          [mapsLink, address] = addressMapsLink(container.street, container.house_number, container.locality);
        } else {
          const splitAddress = container.address.split(',');
          [mapsLink, address] = addressMapsLink(splitAddress[0], splitAddress[1], splitAddress[2]);
        }

        return (
          <Block key={`${container.latitude}:${container.longitude}`} className="text-small u-color-black mb-3" tightLineHeight>
            <div className="d-flex">
              <div>
                <div className="text-bold u-lowercase">{t('container_locations.container_list.closest_location')}: {container.distance} m</div>
                <a target="_blank" rel="noreferrer" href={mapsLink}>{address}</a>
              </div>
              {'container_id' in container && (
                <div className="u-text-right ml-auto u-lowercase">
                  <div>{t('container_locations.container_list.container_number')}:</div>
                  <div>{container.container_id}</div>
                </div>
              )}
            </div>
          </Block>
        );
      })}
      {(filteredContainers.length > visibleContainerCount && visibleContainerCount > 0) && (
        <Button type="text" icon="keyboard_arrow_down" className="ContainerList__item__more" onClick={handleMoreLocationsClick}>
          {t('container_locations.buttons.more_locations')}
        </Button>
      )}
    </div>
  );
};

export default ContainerListItem;
